<template>
  <div>
    <div
      v-if="headerLine"
      class="header-line"
    >
      <div class="fs22">
        {{ $t("myOrders.title") }}
      </div>
      <RouterLink
        :to="{ path: '/my-assets', query: { selectedTitle: $t('briefcase.ordersTabLabel') }}"
      >
        {{ $t("myOrders.all") }}
      </RouterLink>
    </div>

    <div class="content-line">
      <UTable
        v-if="orderLoading || itemsOrders.length > 0"
        class="briefcase-table briefcase-table-hiddable"
        :items="itemsOrders"
        :columns="tableColumns"
        :loading="orderLoading"
      >
        <!-- Слот для колонки с проектом -->
        <template #project="{ value }">
          <div
            class="link link-container"
            @click="toLinkProject(value.id)"
          >
            <img
              class="t-image"
              :src="value.icon"
              alt="cryptoactive"
              @click="toLinkProject(value.id)"
            >
            <div class="block-name">
              <div class="link-text">
                {{ value.name }}
              </div>
              <div class="explain">
                {{ value.type }}
              </div>
            </div>
          </div>
        </template>

        <!-- Слот для колонки с суммой -->
        <template #sum="{ value }">
          <AuDecimalStatic
            v-if="value.mnemonicEng != defaultTokenMnemonic"
            :value="value.value"
            :decimal="value.decimals"
            :indent="value.indent"
            :show-addition="false"
          />
          <AuDecimalStatic
            v-else
            :value="value.sum"
            :decimal="value.decimals"
            :indent="value.indent"
            :show-addition="false"
          />
          <span>{{ value.mnemonicEng }}</span>
        </template>

        <!-- Слот для колонки со статусом -->
        <template #status="{ value }">
          <div class="d-flex justify-content-center">
            <div class="status">
              <div v-if="value?.isCompleted">
                <div class="progress_line">
                  <div>
                    {{ value.statusProject }}
                  </div>
                  <ProgressBar
                    class="indent_progress"
                    :procent="value.procent"
                    :green="value?.procent == 100 ? true : false"
                  />
                </div>
              </div>
              <div v-if="value.isDraft">
                {{ value.statusName }}
              </div>
              <div v-if="!value.isCompleted && value.value">
                <div class="progress_line">
                  <div>
                    {{ value.statusProject }}
                  </div>
                  <ProgressBar
                    class="indent_progress"
                    :procent="value.procent"
                    :green="value.statusProject === 'Waiting' || value.statusProject === 'Open'"
                  />
                  <div class="progress_text">
                    <AuDecimalStatic
                      :value="value.value"
                      :addition="value.addition"
                      :decimal="value.decimal"
                      :indent="value.indent"
                    />
                    <div class="progress_text">
                      <template v-if="value.procent == 0 && value.value > 0">
                        > 0%
                      </template>
                      <template v-else>
                        {{ value.procent + "%" }}
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!value.isDraft && !value.value">
                {{ $t('projects.status.inProcess') }}
              </div>
            </div>
          </div>
        </template>

        <!-- Слот для колонки Cooling-off period -->
        <template #cop="{ value }">
          <div v-if="value?.timeLeft?.refund">
            <div class="label">
              {{ isTimeOff(value.timeLeft?.lastTimeInvest) }}
            </div>
            <div class="mt-1">
              <UButton
                width="80px"
                height="28px"
                @click="modalRefund(value)"
              >
                Refund
              </UButton>
            </div>
          </div>
          <div v-else>
            -
          </div>
        </template>

        <!-- Слот для колонки с сертификатом -->
        <template #certificate="{ value }">
          <div v-if="value?.info == $t('projects.status.completed') || value?.info == $t('projects.status.closed')">
            <AuIcon
              clickable
              icon="paper_download"
              @click="downloadCertificateModify(value.name, value.id)"
            />
          </div>
          <div v-else>
            -
          </div>
        </template>
      </UTable>

      <!-- Пустое состояние -->
      <div
        v-else
        class="order-empty"
      >
        <img
          class="image"
          src="/img/dashboard/not_found_order.svg"
          alt=""
        >
      </div>
    </div>

    <!-- for mobile -->
    <div class="briefcase-accordion">
      <div v-if="itemsOrders != 0">
        <AuAccordion
          v-for="(order, index) in itemsOrders"
          :key="order"
          :last-child="(index == itemsOrders.length - 1)"
        >
          <template #title>
            <div
              class="link link-container"
              @click="toLinkProject(order.project.id)"
            >
              <img
                class="t-image"
                :src="order.project.icon"
                alt="cryptoactive"
                @click="toLinkProject(order.project.id)"
              >
              <div class="block-name">
                <div class="link-text">
                  {{ order.project.name }}
                </div>
                <div class="explain uppercase">
                  {{ order.project.type }}
                </div>
              </div>
            </div>
          </template>
          <template #content>
            <div class="company-info container-fluid">
              <div
                v-for="(column, cindex) in columnsOrdersAccordion"
                :key="cindex"
                class="row"
              >
                <div class="col company-info-title">
                  <span>
                    {{ column.name }}
                  </span>
                </div>
                <div
                  class="col"
                >
                  <div v-if="column.name == $t('briefcase.allocated')">
                    <AuDecimalStatic
                      v-if="column.decimal"
                      :value="order[column.property].value"
                      :decimal="order[column.property].decimals"
                      :show-addition="false"
                    />
                    <span>
                      {{ order[column.property].mnemonicEng }}
                    </span>
                  </div>

                  <div v-if="column.name == $t('briefcase.statusColumn')">
                    <div class="d-flex justify-content-end">
                      <div class="col status">
                        <div v-if="order.status?.isCompleted">
                          <div>
                            {{ order.status?.statusProject }}
                          </div>
                          <ProgressBar
                            class="indent_progress"
                            :procent="order.status?.procent"
                            :green="order.status?.procent == 100 ? true : false"
                          />
                        </div>
                        <div v-if="order.status?.isDraft">
                          {{ order.statusName }}
                        </div>
                        <div v-if="!order.status?.isCompleted && order.status?.value">
                          <div class="progress_line">
                            <div>
                              {{ order.status?.statusProject }}
                            </div>
                            <ProgressBar
                              class="indent_progress"
                              :procent="order.status?.procent"
                              :green="order.status?.statusProject === 'Waiting' || order.status?.statusProject === 'Open'"
                            />

                            <div class="progress_text">
                              <AuDecimalStatic
                                :value="order.status?.value"
                                :addition="order.status?.addition"
                                :decimal="order.status?.decimal"
                                :indent="order.status?.indent"
                              />
                              <div class="progress_text">
                                {{ order.status?.procent + "%" }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="!order.status?.isDraft && !order.status?.value">
                          {{ $t('projects.status.inProcess') }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="column.name == $t('briefcase.startOpen')">
                    <div>
                      {{ order.dateEnd }}
                    </div>
                  </div>

                  <div v-if="column.name == $t('Cooling-off period') && !isNotRwa">
                    <div>
                      <div v-if="order?.cop?.timeLeft?.refund">
                        <div class="label">
                          {{ isTimeOff(order?.cop?.timeLeft?.lastTimeInvest) }}
                        </div>
                        <div class="mt-1">
                          <UButton
                            width="80px"
                            height="28px"
                            @click="modalRefund(order?.cop)"
                          >
                            Refund
                          </UButton>
                        </div>
                      </div>
                      <div v-else>
                        -
                      </div>
                    </div>
                  </div>
                  <div v-if="column.name == $t('Certificate') && !isNotRwa">
                    <div v-if="order?.certificate?.info == $t('projects.status.completed') || order?.certificate?.info == $t('projects.status.closed')">
                      <AuIcon
                        clickable
                        icon="paper_download"
                        @click="downloadCertificateModify(order?.certificate?.name, order?.certificate?.id)"
                      />
                    </div>
                    <div v-else>
                      -
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </AuAccordion>
      </div>

      <span v-else-if="itemsOrders.length == 0">
        No orders yet
      </span>
    </div>

    <AuPagination
      v-if="ordersTotalItems > itemsPerPage && isPagination"
      :hide="orderLoading"
      :total-items="ordersTotalItems"
      @pageChanged="pageChanged"
    />
  </div>
  <UDialog
    v-model:visible="modalVisible"
    title="Cancel Investment"
  >
    <span class="text-surface-500 dark:text-surface-400 block mb-2">You can cancel your <span class="text-surface-500 dark:text-surface-400">
      <b>
        {{ modalData?.mnemonicEng }} <AuDecimalStatic
          :value="modalData?.timeLeft?.sumAmountInvest"
          :decimal="modalData?.decimals"
          :indent="modalData?.indent"
          :show-addition="false"
        />
      </b>
    </span>investment fee-free within 48 hours of placement.</span>

    <span class="text-surface-500 dark:text-surface-400 block mb-2">Time remaining: <b>{{ modalTimeLeft }}</b></span>
    <span class="text-surface-500 dark:text-surface-400 block mb-2">Funds will be returned to your account within 1 business days.</span>
    <div class="flex justify-end gap-2">
      <UButton
        label="Cancel"
        severity="secondary"
        @click="modalVisible = false"
      />
      <UButton
        type="button"
        label="Refund"
        @click="sendRefund"
      />
    </div>
  </UDialog>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import ProgressBar from "@/components/progressBar/ProgressBar";
import UDialog from "@/components/uikit/uComponents/UDialog.vue";
import UTable from "@/components/uikit/uComponents/UTable.vue";
import { checkAccess, checkPostfix, scope } from "@/help/accessData";
import { convertPercent, convertStatus } from "@/components/capital/capitalHelper";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ProgressBar,
    UDialog,
    UTable
  },
  props: {
    itemsPerPage: {
      type: Number,
      default: 30
    },
    headerLine: {
      type: Boolean,
      default: false
    },
    isPagination: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      modalVisible: false,
      modalData: null,
      orderLoading: true,
      dataOrders: null,
      ordersTotalItems: null,
      pageId: 1
    };
  },

  computed: {
    ...mapGetters({
      language: "language",
      tokens: "tokens",
      dataLoading: "withdrawal/dataLoading",
      isTestRole: "profile/isTestRole",
      defaultTokenMnemonic: "defaultToken/defaultTokenMnemonic",
      defaultTokenId: "defaultToken/defaultTokenId"
    }),

    postfix() {
      return checkPostfix();
    },

    isNotRwa() {
      return checkAccess(scope.notRwa);
    },

    modalTimeLeft() {
      if (!this.modalData?.timeLeft?.lastTimeInvest) {
        return null;
      }
      return this.isTimeOff(this.modalData.timeLeft.lastTimeInvest);
    },

    // Computed колонки для UTable - автоматически обновляются при изменении языка или isNotRwa
    tableColumns() {
      const projectTitleHeader = process.env.VUE_APP_PROJECT_TITLE_TYPE == "name"
        ? this.$t("briefcase.projectName")
        : this.$t("briefcase.projectSymbol");

      const columns = [
        {
          property: "project",
          header: projectTitleHeader,
          align: "start"
        },
        {
          property: "sum",
          header: this.$t("briefcase.allocated"),
          align: "center"
        },
        {
          property: "status",
          header: this.$t(`briefcase.statusColumn${this.postfix}`),
          align: "center"
        },
        {
          property: "dateEnd",
          header: this.$t("briefcase.startOpen"),
          align: "center"
        }
      ];

      if (!this.isNotRwa) {
        columns.push(
          {
            property: "cop",
            header: this.$t("Cooling-off period"),
            align: "center"
          },
          {
            property: "certificate",
            header: this.$t("Certificate"),
            align: "center"
          }
        );
      }

      return columns;
    },

    itemsOrders() {
      return _.map(this.dataOrders, item => {
        const auCapital = {
          currentCap: item?.currentCap,
          maxCap: item?.maxCap,
          minCap: item?.minCap,
          minCount: item?.minCount,
          dateStart: item?.dateStart,
          isClosed: item?.isClosed,
          isSuccess: item?.isSuccess,
          dateEnd: item?.dateEnd
        };

        return {
          id: item?.id,
          project: {
            name: process.env.VUE_APP_PROJECT_TITLE_TYPE == "name" ? item?.nameEng : item?.tokenBase?.mnemonicEng,
            id: item?.id,
            icon: item?.mainImage?.name || "/svg/light/grid_round_green.svg",
            type: this.prepareTransactionNotes(item?.projectType)
          },
          sum: {
            value: item?.amount,
            decimals: item?.tokenQuote?.decimals,
            indent: item?.tokenQuote?.indent,
            mnemonicEng: item?.tokenQuote?.mnemonicEng,
            rateDefaultToken: item?.rateDefaultToken,
            sum: item.sum
          },
          status: {
            statusName: item?.isDraft ? this.$t("projects.status.draft") :
              (item?.isCompleted ? this.$t("projects.status.approved") : this.$t("projects.status.inProcess")),
            isDraft: item?.isDraft,
            isCompleted: item?.isCompleted,
            value: auCapital?.currentCap,
            decimal: item?.tokenQuote?.decimals,
            indent: item?.tokenQuote?.indent,
            addition: item?.tokenQuote?.mnemonicEng,
            procent: convertPercent(auCapital),
            statusProject: convertStatus(auCapital)
          },
          dateEnd: this.formatDate(item?.dateEnd),
          ...(!this.isNotRwa && {
            cop: { // Cooling-off period
              timeLeft: this.isRightTime(item?.log),
              decimals: item?.tokenQuote?.decimals,
              indent: item?.tokenQuote?.indent,
              mnemonicEng: item?.tokenQuote?.mnemonicEng,
              id: item?.id
            }
          }),
          certificate: {
            amount: item?.amount,
            status: "close",
            info: convertStatus(auCapital),
            name: process.env.VUE_APP_PROJECT_TITLE_TYPE == "name" ? item?.nameEng : item?.tokenBase?.mnemonicEng,
            id: item?.id
          }
        };
      });
    },

    columnsOrdersAccordion() {
      const columns = [
        { name: `${this.$t("briefcase.allocated")}`, align: "center", slot: "sum", property: "sum", decimal: true },
        { name: `${this.$t("briefcase.statusColumn")}`, align: "center", slot: "status", property: "status", decimal: true },
        { name: this.$t("briefcase.startOpen"), align: "center", slot: "dateEnd", property: "dateEnd" }
      ];
      if (!this.isNotRwa) {
        columns.push(
          { name: this.$t("Cooling-off period"), align: "center", slot: "cop", property: "cop" },
          { name: this.$t("Certificate"), align: "center", slot: "certificate", property: "certificate" }
        );
      }
      return columns;
    },

    isLightTheme() {
      return this.$store.getters.isLightTheme;
    }
  },

  async mounted() {
    this.timer = setInterval(() => {
      if (this.dataOrders) {
        this.dataOrders = [...this.dataOrders];
        // если модалка открыта
        if (this.modalVisible && this.modalData?.id) {
          const updatedOrder = this.dataOrders.find(item => item.id === this.modalData.id);
          if (updatedOrder) {
            this.modalData = {
              ...this.modalData,
              timeLeft: this.isRightTime(updatedOrder.log)
            };
          }
        }
      }
    }, 30000);
    this.defaultToken = _.find(this.tokens, token => token.id == this.defaultTokenId);
    await this.getOrdersPage();
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },

  methods: {
    ...mapActions({
      getInvestmentsAuCapitals: "capitals/getInvestmentsAuCapitals",
      cancelInvestment: "capitals/cancelInvestment",
      getCertificate: "getCertificate"
    }),

    modalRefund(item) {
      this.modalData = item;
      this.modalVisible = true;
    },

    async sendRefund() {
      try {
        await this.cancelInvestment(`/api/au_capitals/${this.modalData.id}`);
        this.$toast.success(this.$t("The refund request has been processed."));
      }
      catch (error) {
        console.log(error);
        this.$toast.error(this.$t("Something's wrong. Try again later"));
      }
      finally {
        this.modalVisible = false;
        setTimeout(() => {
          this.getOrdersPage();
        }, 15000);
      }
    },

    isRightTime(log) {
      if (!log || !Array.isArray(log) || log.length === 0) {
        return null;
      }

      let latestDate = null;
      let latestItem = null;
      let allAmount = 0;

      for (const item of log) {
        const dateStr = item.createdAt;
        if (dateStr) {
          const currentDate = new Date(dateStr);
          if (!isNaN(currentDate.getTime())) {
            // Проверяем является ли текущая дата самой поздней
            if (latestDate === null || currentDate > latestDate) {
              latestDate = currentDate;
              latestItem = item;
            }

            // Отправляем дату в isTimeOff и проверяем результат
            const timeOffResult = this.isTimeOff(dateStr);
            if (timeOffResult !== null && timeOffResult !== undefined) {
              // Суммируем amount, если это число
              const amountValue = parseFloat(item.amount);
              if (!isNaN(amountValue)) {
                allAmount += amountValue;
              }
            }
          }
        }
      }

      return {
        lastTimeInvest: latestItem?.createdAt || null,
        sumAmountInvest: allAmount.toString(),
        refund: this.isTimeOff(latestItem?.createdAt) ? true : false
      };
    },

    isTimeOff(time, isMinuts = true) {
      if (!time) {
        return null;
      }

      const timeDate = new Date(time);
      const actDate = new Date();
      const timePlus48Hours = new Date(timeDate.getTime() + 48 * 60 * 60 * 1000);

      // Разница в миллисекундах
      const diffMs = timePlus48Hours - actDate;

      if (diffMs <= 0) {
        return null;
      }

      // Конвертируем в часы и минуты
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

      // Меньше часа - всегда минуты
      if (diffHours < 1) {
        return diffMinutes >= 1 ? `${diffMinutes} minuts` : null;
      }

      // Больше или равно часа
      if (isMinuts) {
        return `${diffHours} hours ${diffMinutes} minuts`;
      }
      else {
        return `${diffHours} hours`;
      }
    },

    async downloadCertificate(index) {
      await this.getCertificate({
        name: this.itemsOrders[index].project.name,
        id: this.itemsOrders[index].project.id
      });
    },

    async downloadCertificateModify(name, id) {
      await this.getCertificate({
        name: name,
        id: id
      });
    },

    toLinkProject(link) {
      this.$router.push({ name: "project card", params: { id: link } });
    },

    toLink(link) {
      this.$router.push({ name: "token info", params: { id: link } });
    },

    async getOrdersPage() {
      this.orderLoading = true;
      try {
        let resp = await this.getInvestmentsAuCapitals({
          pageId: this.pageId,
          itemsPerPage: this.itemsPerPage,
          status: this.isNotRwa ? "open" : null
        });

        this.dataOrders = resp.data;
        this.ordersTotalItems = resp.totalItems;
      }
      catch (e) {
        console.log("error", e);
      }
      finally {
        this.orderLoading = false;
      }
    },

    async pageChanged(actualPage) {
      this.pageId = actualPage;
      await this.getOrdersPage();
    },

    prepareTransactionNotes(projectType) {
      switch (projectType) {
        case "voting":
          return this.$t("projects.status.voting");
        case "invest_v2":
          return this.isTestRole ? this.$t("projects.status.participation") + " [v2]" : this.$t("projects.status.participation");
        case "invest":
          return this.isTestRole ? this.$t("projects.status.participation") + " [v1]" : this.$t("projects.status.participation");
        default:
          return projectType;
      }
    },

    formatDateRange(startDate, endDate) {
      const formatMonth = (date) => {
        if (this.language === "ru") {
          return moment(date)
            .locale("ru")
            .format("DD MMM YYYY")
            .replace(/\./, "")
            .replace(/[а-я]+/g, (month) => month.charAt(0).toUpperCase() + month.slice(1));
        }
        return moment(date).locale("en").format("DD MMM YYYY");
      };

      return formatMonth(startDate) + " - " + formatMonth(endDate);
    },

    formatDate(newDate) {
      if (!newDate) {
        return "";
      }

      const formatMonth = (date) => {
        if (this.language === "ru") {
          return moment(date)
            .locale("ru")
            .format("DD MMM YYYY")
            .replace(/\./, "")
            .replace(/[а-я]+/g, (month) => month.charAt(0).toUpperCase() + month.slice(1));
        }
        return moment(date).locale("en").format("DD MMM YYYY");
      };

      return formatMonth(newDate);
    }
  }
};
</script>

<style scoped lang="scss">
/* Стили остаются без изменений */
.header-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    padding-top: 4px;
    font-size: 13px;
    color: #279063;
    text-decoration: none;
  }
}
.briefcase {
  &-info {
    padding: 11px 20px 0 18px;

    .title {
      font-weight: 600;
      font-size: 24px;
      color: var(--text-color);
      margin-bottom: 30px;
    }
  }

  &-table {
    margin-top: 10px;
    margin-bottom: 10px;

    &-hiddable {
      @media screen and (max-width:590px) {
        display: none;
      }
    }
  }

  &-accordion {
    margin-top: 10px;
    display: none;

    @media screen and (max-width:590px) {
      display: block;
    }
  }
}

.spot-balance {
  color: var(--color-50);
  font-weight: 500;
  font-size: 12px;
}

.company {
  &-header {
    color: var(--text-color);
    font-size: 12px;
  }

  &-info {
    color: var(--text-color);
    display: flex;
    padding-right: 0;
    padding-left: 0;
    flex-direction: column;
    gap: 20px;

    &-title {
      color: var(--color-60)
    }

    .row {
      font-weight: 450;
      font-size: 12px;

      .col:last-child {
        text-align: end;
      }

      .buttons {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
    }
  }

}

.icon-with-bg {
  width: 25px;
  height: 25px;
  margin-right: 8px;
  opacity: var(--opacity);
}

.link-container {
  display: flex;
  align-items: center;
}

.link {
  &:hover {
    cursor: pointer;
  }
  display: flex;
  align-items: center;
  .block-name {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .link-text {
      &:hover {
        text-decoration: underline;
        text-decoration-thickness: 1px;
        text-decoration-color: var(--color-00);
        text-decoration-style: dashed;
        text-underline-offset: 4px;
      }
    }
    .explain {
      font-weight: 450;
      font-size: 12px;
      color: var(--color-60);
      @media screen and (max-width:384px) {
        line-height: 1.1;
      }
    }
  }
}
.briefcase-tooltip {
  margin-left: 2px;
}
.t-image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
  &:hover {
    cursor: pointer;
  }
}
.progress_line {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.progress_text {
  display: flex;
  justify-content: space-between;
  font-weight: 450;
  font-size: 12px;
  color: var(--color-20);
}
.indent_progress {
  margin-top: 6px;
  width: 100%;
}
.status {
  width: 135px;
}
.uppercase::first-letter {
  text-transform: uppercase;
}
.order-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .image {
    width: 400px;
    height: 300px;
    @media screen and (max-width: 900px) {
      width: 200px;
      height: 194px;
    }
  }
}
.label {
  font-weight: 450;
  font-size: 12px;
  color: var(--color-60);
  @media screen and (max-width:384px) {
    line-height: 1.1;
  }
}

.briefcase-table-hiddable {
  @media screen and (max-width:670px) {
    display: none;
  }
}
</style>